module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"see_more":"もっと見る"}}')
  delete Component.options._Ctor
}
